import * as React from 'react';
export var AutoCompleteItem = function (_a) {
    var name = _a.name, isHighlighted = _a.isHighlighted, onSelect = _a.onSelect, _b = _a.value, value = _b === void 0 ? name : _b;
    return (React.createElement("li", { onClick: function () { return onSelect(value); }, className: isHighlighted ? 'active' : '' },
        React.createElement("div", { className: "list-group-item-name" },
            React.createElement("p", null, name))));
};
//# sourceMappingURL=AutoCompleteItem.js.map